<template>
  <rabbey-table-3
    ref="rTable"
    :data="items"
    :columns="columns"
    :row-style="{ textAlign: 'center' }"
    :border="true"
    :stripe="true"
    :actions="actions"
    :filterList="filterList"
    :search="search"
    :default-items="getCustomers"
    :loading="loading"
    paginateFromApi
    :paginationApi="paginationApi"
    :pageSizes="paginationApi.pageSizes"
    @rtable-push-action="$emit('rtable-push-action', $event)"
    @update-current-page="$emit('update-current-page', $event)"
    @update-page-size="$emit('update-page-size', $event)"
  />
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import { PAGINATION_DEFAULT } from "@/const";
import COLUMNS from "@/columns/customer";

export default {
  name: "CustomerTable2",
  props: {
    items: {
      type: Array,
      default: () => []
    },
    actions: {
      type: Array,
      default: () => []
    },
    search: {
      type: String,
      default: null,
      required: false
    },
    filterList: {
      type: Array,
      default: null,
      required: false
    },
    loading: {
      type: Boolean,
      default: false,
      required: true
    },
    paginationApi: {
      type: Object,
      required: false,
      default: () => ({
        currentPage: 1,
        pageSize: 10,
        pageSizes: [10, 20, 30, 50, 500],
        total: 0
      })
    }
  },
  data() {
    return {
      columns: COLUMNS,
      filter: ""
    };
  },
  created() {
    this.setUrl("");
    this.setOriginalItems(this.getCustomers);
    this.paginate(PAGINATION_DEFAULT);
  },
  methods: {
    ...mapMutations({
      setOriginalItems: "rabbey_table/originalItems",
      setUrl: "rabbey_table/url"
    }),
    ...mapActions({ paginate: "rabbey_table/paginate" }),
    onPushAction(c) {
      switch (c.command) {
        case "view": {
          this.$refs.details.drawer = true;
          this.data = c.row;
          break;
        }
        default:
          break;
      }
    }
  },

  computed: {
    ...mapState({ customers: (state) => state.customers.dbListByCompany }),
    getCustomers() {
      return this.customers[this.currentCompany];
    }
  }
};
</script>
